<template>
    <v-card class="panelBlock ma-2 conduct-terms">
        <v-layout row wrap>
            <v-flex xs12 tag="h2">{{ SpeakerApplicants.RESOURCE_DIRECTORY }}</v-flex>
            <v-flex class="resources inner-scrollbar">
                <v-flex v-if="showBecomeSpeaker" class="resources__list-items">
                    <span>
                        <a :href="'#/speakers'"
                           :class="[showBecomeSpeaker ? 'urls' : 'disable_urls']" data-qe-id="become_a_speaker"
                           :target="linkTarget">
                          {{ SpeakerApplicants.BECOME_A_SPEAKER }}
                        </a>
                    </span>
                </v-flex>
                <v-flex class="resources__list-items">
                    <span>
                        <a @click="hideResourceSection(SpeakerApplicants.SPEAKER)" class="urls" data-qe-id="find_a_speaker_link">{{SpeakerApplicants.SEARCH_FOR_SPEAKER}} </a>
                    </span>
                </v-flex>
                <v-flex class="resources__list-items">
                    <span>
                        <a @click="hideResourceSection(SpeakerApplicants.IS_CFF_SPEAKER)" class="urls" data-qe-id="find_a_CFF_link">{{SpeakerApplicants.FIND_A_CFF}} </a>
                    </span>
                </v-flex>
                <v-flex class="resources__list-items resources__view-edit-speaker" v-if="(speakerRegistrationStatus === 'A' || speakerRegistrationStatus === 'P')">
                    <span>
                        <a target="_self" @click="hideMyTools()" class="urls" data-qe-id="view_speaker_profile">
                            {{ getViewEditSpeakerLinkText(speakerRegistrationStatus) }}
                        </a>
                        <a target="_self" @click="hideMyTools()" class="urls" data-qe-id="view_speaker_profile">
                            {{ SpeakerApplicants.PENDING_APPROVAL }}
                        </a>
                    </span>
                </v-flex>
                 <v-flex class="resources__list-items"  v-if="speakerRegistrationStatus === 'A'">
                    <span>
                       
                        <a class="urls" @click="resourceDirectoryLink(SpeakerApplicants.RESOURCE_DIRECTORY_TERMS_OF_USE)" data-qe-id="Resource_directory" :target="linkTarget">{{SpeakerApplicants.RESOURCE_DIRECTORY_TERMS_OF_USE }}
                        </a>
                    </span>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import ClickOutside from 'vue-click-outside';
    import { SpeakerApplicants } from '../Speakers/speakerConstant';
    import { mapGetters, mapMutations } from 'vuex';
    import { storeGetters } from '../../store/storeGetters.constant';
    import { storeMutation } from '../../store/storeMutations.constant';

    export default {
        name: 'ResourceDirectoryTile',
        data: () => ({
            menuPanel: [],
            SpeakerApplicants,
        }),
        props: {
            showHideTools: {
                type: Function,
            },
        },

        directives: {
            ClickOutside,
        },
        methods: {
            ...mapMutations({
                setPrevRouteUrlName: `speaker/${storeMutation.setPrevRouteUrlName}`,
                setSpeakerStatus: `speaker/${storeMutation.setSpeakerStatus}`,
            }),
            openFindSpeaker() {
                this.$router.push({
                    path: '/YPOSpeaker',
                });
            },
            resourceDirectoryLink(displayName) {
                const linkObjects = this.termsPrivacyURLs.find(item => item.name.toLowerCase() === displayName.toLowerCase());
                window.open(linkObjects.navigationUrl, '_blank');
            },
            hideMyTools() {
                sessionStorage.removeItem(SpeakerApplicants.SPEAKER_TYPE);
                sessionStorage.removeItem(SpeakerApplicants.SPEAKER_STATUS);
                sessionStorage.removeItem(SpeakerApplicants.SPEAKER_TYPE);

                this.showHideTools();
                sessionStorage.setItem(SpeakerApplicants.SPEAKER_TYPE, 'member');
                sessionStorage.setItem(SpeakerApplicants.SPEAKER_STATUS, this.speakerRegistrationStatus);
                this.$router.push({
                    path: `/speakerPage/speakerProfile`,
                    query: {
                        id: this.currentUserId,
                    },
                });
            },

            getViewEditSpeakerLinkText(status) {
                return status && status === 'A' ?
                    this.SpeakerApplicants.VIEW_SPEAKER_PROFILE :
                    this.SpeakerApplicants.VIEW_SPEAKER_PROFILE_PENDING;
            },
            hideResourceSection(searchCriteria) {
                this.showHideTools();
                if (searchCriteria === this.SpeakerApplicants.SPEAKER) {
                    this.$router.push({
                        path: `/speakerPage/SearchSpeakers`,
                    });
                } else if (searchCriteria === this.SpeakerApplicants.IS_CFF_SPEAKER) {
                    this.$router.push({
                        path: `/speakerPage/SearchSpeakers`,
                        query: {
                            speakersWhoAre: searchCriteria,
                        },
                    });
                }
            },
        },
        computed: {
            ...mapGetters({
                speakerRegistrationStatus: `speaker/${storeGetters.speakerRegistrationStatus}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,                
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
                termsPrivacyURLs: `openAPI/${storeGetters.termsPrivacyURLs}`,
            }),
            linkTarget() {
                return this.isMobileAppBrowser ? '_self' : '_blank';
            },
            showBecomeSpeaker() {
                return this.speakerRegistrationStatus === '' || this.speakerRegistrationStatus === 'R';
            },
        },
    };
</script>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .left-side-bar {
        .conduct-terms {
            margin: 0 !important;

            .resources__list-items {
                border-bottom: 1px solid $ypo-medium-gray;
                padding: 15px 15px;
            }
        }
    }

    .resources {
        border: none;

        .left-heading {
            padding: 20px 0 20px 20px;
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 14px;
            background: $white;
            border-top: 1px solid $ypo-extra-light-gray;
            text-align: left;
        }

        .is-disabled {
            opacity: 0.5;
            pointer-events: none;
        }

        &-social {
            text-align: center;
            background: $white;
            padding-bottom: 10px;

            span {
                display: inline-block;
                margin: 0 13px;
                font-size: 24px;

                a {
                    color: $ypo_blue;
                    transition: 0.2s;

                    &:hover {
                        color: $ypo-cta;
                    }
                }
            }

            &__single {
                text-align: center;
                background: $white;
                padding: 5px 0 15px 0;

                a {
                    color: $ypo-cta;
                    font-size: 12px;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }

        &__list-items {
            text-align: left;
            border-top: 1px solid $ypo-extra-light-gray;
            padding: 10px 15px;

            .urls {
                margin: 0 !important;
            }

            .disable_urls {
                pointer-events: none;
                opacity: 0.5;
                margin: 0 !important;
                text-decoration: none;
            }

            &__info {
                color: $ypo-gold !important;
                font-weight: 600 !important;
            }
        }

        &__view-edit-speaker {
            .urls {
                &:last-child {
                    color: $ypo-gold;
                    font-weight: 600;

                    &:hover {
                        color: $ypo-gold;
                    }
                }
            }
        }

        .heading {
            color: $ypo-cta;
            font-size: 14px;
            font-weight: bold;
            line-height: 18px;
        }

        .urls {
            text-decoration: none;
            transition: 0.3s;
            font-size: 14px;
            font-weight: 500;
            color: $ypo-cta;
            margin-top: 15px;
            display: inline-block;
            margin-left: 20px;

            &:hover {
                text-decoration: underline;
                color: $ypo_blue;
            }
        }

        &__list {
            &:first-child {
                padding-top: 20px;
            }
        }

        .v-expansion-panel {
            box-shadow: none;

            &__container {
                border-top: 1px solid $ypo-extra-light-gray !important;

                &__main {
                    position: relative;
                    transition: 2s;

                    &:hover {
                        background: $ypo-extra-light-gray;
                    }
                }

                .v-expansion-panel__header {
                    padding: 10px 15px;
                    min-height: inherit;
                    position: relative;
                    background: $white;
                }

                &--active {
                    background: $ypo-extra-light-gray;
                    position: relative;

                    &.url-links {
                        padding: 5px 30px 10px 30px;
                        background: transparent;
                    }

                    .v-expansion-panel__header {
                        background: $white;

                        .heading {
                            color: $ypo_blue;
                        }
                    }

                    .v-expansion-panel__body {
                        background: rgba($ypo-cta, 0.03);
                        padding-bottom: 20px;

                        .v-card {
                            background: transparent;
                        }
                    }
                }
            }
        }
    }
</style>
